export default __webpack_public_path__ + "st-images/dai.gif";